import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * Emaar
 */
const factory = function factory({ window, document, thn }) {
    // let refreshPrice: ReturnType<typeof thn.debounce> | null;
    const roomDetailsParseData = (adults, children) => {
        const roomsArray = Array.from(document.querySelectorAll('#roomsListContainer>.row'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray.map((room) => {
            const roomName = room.querySelector('.card-title')?.textContent;
            const roomType = getRoomType(roomName ?? undefined);
            const ratesInfo = Array.from(room.querySelectorAll('.rate_info_item')).map((rate) => {
                const rateName = rate.querySelector('#room__offer label')?.textContent?.trim();
                const ratePrice = thn.parseNumber(room.querySelector('.room_rate_offer[data-val]')?.textContent);
                const hasBreakfast = false;
                const isRefundable = !!rateName?.match(/flexible|/i);
                if (!rateName || !ratePrice) {
                    return null;
                }
                return {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
            }).filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            return {
                name: roomName,
                type: roomType,
                adults,
                children,
                prices: ratesInfo,
            };
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        isUserLogged() {
            const isLogged = thn.dataLayerHelper.get('loggedIn') !== 'no';
            return isLogged;
        },
        priceObserveDom(ctx) {
            const container = document.querySelector('#roomsListContainer');
            if (container) {
                const debouncedRefresh = thn.debounce(() => ctx.widget.refresh(), 400);
                const refreshPrice = (mutations) => {
                    const priceUpdate = mutations.filter((mutation) => mutation.target && mutation.target instanceof Element && (mutation.target.className?.match(/rate_plan_price/)));
                    if (!thn.empty(priceUpdate)) {
                        return debouncedRefresh();
                    }
                };
                thn.observeDom(container, refreshPrice, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                    characterData: true,
                });
                thn.pageUnload(() => {
                    debouncedRefresh.cancel();
                    thn.stopObserveDom(container, refreshPrice);
                });
            }
        },
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = url.pathname.includes('/find/rooms/');
            // https://adhstage.emaar.com/en/find/rooms/?id=1&hotelname=Address%20Downtown%20&cid=18/04/25&cod=19/04/25&nights=1&rooms=1&adult=1&child=0&type=&code=&iata=&room_currency_code=&bfse=&rateplancode=&roomtypeid=&prodid=&redirect=no-rooms&offer_code=&offer_name=&offer_id=
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceParseData() {
            // Guests, Adults & Children
            const roomNumber = thn.parseNumber(document.querySelector('.room-list-selectRoom')?.textContent) ?? 1;
            const roomInfo = Array.from(document.querySelectorAll('.addRoomsDropdown [id*="table_widge"].table'))?.map((room) => {
                const adults = thn.parseNumber(room.querySelector('.count_adult')?.textContent) ?? 2;
                const children = thn.parseNumber(room.querySelector('.count_child')?.textContent) ?? 0;
                const childrenAges = [];
                if (children) {
                    for (let i = 0; i < children; i += 1) {
                        childrenAges.push(10);
                    }
                }
                return { adults, children, childrenAges };
            });
            // Dates
            const dateBeginValue = document.querySelector('#cid')?.value || thn.parseUrlParameter('cid');
            const dateEndValue = document.querySelector('#cod')?.value || thn.parseUrlParameter('cod');
            const dateBegin = dateBeginValue?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '20$3/$2/$1');
            const dateEnd = dateEndValue?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '20$3/$2/$1');
            if (!dateBegin || !dateEnd) {
                return null;
            }
            // Prices & Currency || No Rooms
            const pricesArray = Array.from(document.querySelectorAll('.room_rate_offer'))?.map((rate) => {
                const price = thn.parseNumber(rate?.textContent);
                const currency = thn.parseCurrency(rate?.textContent);
                return price && currency ? { price, currency } : null;
            }).filter((value) => value !== null);
            const price = Math.min(...pricesArray.map((rate) => rate.price).filter((value) => value !== null));
            const currency = pricesArray[0]?.currency;
            if (price && currency) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [roomInfo[roomNumber - 1]],
                    roomDetails: roomDetailsParseData(roomInfo[roomNumber - 1].adults, roomInfo[roomNumber - 1].children),
                    price,
                    currency,
                };
            }
            if (thn.empty(pricesArray)) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [roomInfo[roomNumber - 1]],
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            // Multi room booking
            const bookingItems = Array.from(document.querySelectorAll('.roomtype-infobox:not(.chevron)'))?.map((item) => {
                // Booking ID
                const bookingId = item.querySelector('.booking-confirm-details>span>span')?.textContent;
                if (!bookingId) {
                    return {
                        set: false,
                    };
                }
                // Dates
                const dateBeginValue = thn.dataLayerHelper.get('check-in-date');
                const dateBegin = dateBeginValue?.replace(/-/g, '/');
                const dateEndValue = thn.dataLayerHelper.get('check-out-date');
                const dateEnd = dateEndValue?.replace(/-/g, '/');
                // Price & Currency
                const priceText = item.querySelector('span.booking-confirm-details')?.textContent;
                const price = thn.parseNumber(priceText);
                const currency = thn.parseCurrency(priceText);
                return {
                    bookingId,
                    dateBegin,
                    dateEnd,
                    price,
                    currency,
                };
            });
            return bookingItems;
        },
    };
};

export { factory };
